<div class="preloader">
  <img src="./assets/img/loading.gif" class="img-fluid mx-auto d-block">
</div>
